import { lazy } from "@loadable/component";
import { AuthRoles } from "../../configs/roles";
import { Loadable } from "../components/template/partials";

// Menu
import { DocumentationRoutes } from "app/modules/documentation";
import { AccountRoutes } from "../modules/account";
import { CustomerRoutes } from "../modules/costumer";
import { ScheduleRoutes } from "../modules/schedule";
import { UserManagementRoutes } from "../modules/user-management";
const DashboardPage = Loadable(
  lazy(() => import("../pages/dashboard/DashboardPage"))
);

const PrivateRoutes = [
  {
    path: "/dashboard",
    element: <DashboardPage />,
    auth: AuthRoles.ROLES_USER,
  },
  ...AccountRoutes,
  ...CustomerRoutes,
  ...ScheduleRoutes,
  ...UserManagementRoutes,
  ...DocumentationRoutes,
];
export default PrivateRoutes;
